import React, { FunctionComponent, useState, ChangeEvent, MouseEvent, useRef, useEffect } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { useMutation } from '@apollo/react-hooks'
import MediaQuery from 'react-responsive'
import { BREAK_MD } from 'src/lib/media-queries'
import camelCase from 'lodash/camelCase'

const updateEventMutation = require('./Event-update.gql')
import locale from './locale'

const style = require('./EditTextButton.css')

interface Props {
  listing,
  canDesign: boolean,
  setTicketButtonText: Function,
  ticketButtonText: String,
}

const EditTextButtonComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  listing,
  canDesign,
  setTicketButtonText,
  ticketButtonText,
  intl: { formatMessage },
}) => {
  const [open, setOpen] = useState(false)
  const buttonNode = useRef(null)
  const [backupButtonText, setBackupButtonText] = useState(ticketButtonText)
  const texts = listing.timedEntry ? [
    'get_tickets',
    'see_dates',
    'register',
    'rsvp',
    'donate'
  ] : [
    'get_tickets',
    'register',
    'rsvp',
    'donate'
  ]
  const [updateEvent] = useMutation(updateEventMutation, {
    onCompleted(data) {
      // if there are errors on web (not apollo-gql client errors), rollback the ticket button text
      // else if there aren't any errors, update the backup button text
      if (data?.eventUpdate?.errors?.length > 0) setTicketButtonText(data.eventUpdate.event.getTicketsText)
      else setBackupButtonText(data.eventUpdate.event.getTicketsText)
    },
    onError(data) {
      // if there are apollo-gql client errors, rollback the ticket button text to its most recent valid state
      setTicketButtonText(backupButtonText)
    }
  })

  const handleClickOutside = e => {
    if (buttonNode.current.contains(e.target)) {
      return
    }

    setOpen(false)
  }

  const changeText = (text: string) => {
    updateEvent({ variables: { id: listing.id, getTicketsText: text } })
    setTicketButtonText(text)
  }

  const handleTextChangeMobile = (event: ChangeEvent<HTMLSelectElement>) => {
    if (event && event.currentTarget && event.currentTarget.value) {
      updateEvent({ variables: { id: listing.id, getTicketsText: event.currentTarget.value } })
      setTicketButtonText(event.currentTarget.value)
    }
  }

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [open])

  const mobileOptions = texts.map(text => {
    return (
      <option key={text} value={text}>{formatMessage(locale[camelCase(text)])}</option>
    )
  })

  const options = []
  texts.forEach((text) => {
    const active = ticketButtonText == text
    options.push(
      <div className={active ? [style.selector__option, style.active].join(' ') : style.selector__option}
        key={text}
        onClick={(e) => changeText(text)}>
        <a>
          {formatMessage(locale[camelCase(text)])}
        </a>
      </div>
    )
  })

  if (canDesign) {
    return (
      <div>
        <MediaQuery maxWidth={BREAK_MD - 1}>
          <div className={style['editTextButton--mobile']}>
            <select onChange={(e) => handleTextChangeMobile(e)} value="T">
              <option value="T" disabled hidden>T</option>
              {mobileOptions}
            </select>
          </div>
        </MediaQuery>
        <MediaQuery minWidth={BREAK_MD}>
          <div ref={buttonNode} className={style.editTextButton}>
            <a onClick={(e) => setOpen(!open)}>T</a>
            <div className={open ? [style.selector, style.expanded].join(' ') : [style.selector, style.closed].join(' ')}>
              <div className={style.selector__triangle} />
              {options}
            </div>
          </div>
        </MediaQuery>
      </div>
    )
  }
  return null
}

export const EditTextButton = injectIntl(EditTextButtonComponent)